export default "__VITE_ASSET__DEBVW4Ot__"